import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { UpdateReadStatusNotificationByIdGQL } from '../../../../generated/gatewaygql';
import { HeaderTemplateData } from '../dialog-data.interface';

export interface DialogData {
    title: string;
    item: any;
    noButtonText: string;
    yesButtonText: string;
    header: any;
}

@Component({
    selector: 'app-notification-dialog',
    templateUrl: './notification-dialog.html',
})
export class NotificationDialogComponent implements OnInit {
    result: DialogData;
    form: FormGroup;
    remark: string;
    header:HeaderTemplateData;

    constructor(
        public dialogRef: MatDialogRef<NotificationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: DialogData,
        private updateReadStatusNotificationByIdGQL: UpdateReadStatusNotificationByIdGQL
    ) {

        if (_data != null) {
            this.header = _data.header;
            this.result = _data;
        }

    }

    ngOnInit(){

    }


    onSubmit(item: any) {

        this.updateReadStatusNotificationByIdGQL.mutate({
            RecordID: this.result.item.recordId
        }).subscribe(x => {
            this.dialogRef.close(x.data.UpdateReadStatusNotificationByID);
            window.location.reload();
        });

    }

}
